import PropTypes from 'prop-types';
import React from 'react';
import { Icon, IconWrapper } from '@honda-canada/design-system-react';

const AccordionItemTitleIcon = ({ ariaLabel, iconColor, iconName, isActive }) => (
  <IconWrapper position="relative" aria-label={ariaLabel}>
    <Icon iconColor={iconColor} name={iconName} toggle={isActive} />
  </IconWrapper>
);

AccordionItemTitleIcon.propTypes = {
  isActive: PropTypes.bool.isRequired,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default AccordionItemTitleIcon;
